import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { PackagesComponent } from 'src/app/packages-module/packages/packages.component';
import { PackagesAddComponent } from 'src/app/packages-module/packages-add/packages-add.component';
import { PackagesViewComponent } from 'src/app/packages-module/packages-view/packages-view.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalModule } from 'src/app/modal/modal.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SharedComponentsModule } from 'src/app/shared-components-module/shared-components.module';
import { PackageEditComponent } from './package-edit/package-edit.component';
import { SearchListComponent } from './components/search-list/search-list.component';
import { SearchManagementDialogComponent } from './components/search-management-dialog/search-management-dialog.component';
import { MaterialModule } from '../shared-components-module/material.module';
import { SearchAddDialogComponent } from './components/search-add-dialog/search-add-dialog.component';
import { PackagesAssignComponent } from './packages-assign/packages-assign.component';
import { ClientPackageEditComponent } from './client-package-edit/client-package-edit.component';
import { EditableSearchListComponent } from './components/editable-search-list/editable-search-list.component';


const routes: Routes = [
  {path: 'packages', component: PackagesComponent},
  {path: 'packages/new', component: PackagesAddComponent},
  {path: 'packages/edit/:pkg', component: PackageEditComponent},
  {path: 'packages/edit/:pkg/:clnt', component: PackageEditComponent}, // For Client Specific Pkg mgt(pricing)
  {path: 'packages/review/:pkg', component: PackagesViewComponent}
];

@NgModule({
    declarations: [
        PackagesComponent,
        PackagesAddComponent,
        PackagesViewComponent,
        PackageEditComponent,
        PackagesAssignComponent,
        SearchListComponent,
        SearchManagementDialogComponent,
        SearchAddDialogComponent,
        ClientPackageEditComponent,
        EditableSearchListComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        NgbdModalModule,
        AngularEditorModule,
        PipesModule,
        BrowserModule,
        MaterialModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SharedComponentsModule,
        RouterModule.forRoot(routes),
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            preventDuplicates: false,
        }), // ToastrModule added
    ]
})
export class PackagesModule { }
